import { observer } from "mobx-react";
import React, { Component } from "react";
import footer_left_brands from "../../assets/images/footer_brand.svg";
import Image from "../Image";
import classes from "./styles.module.scss";
@observer
class Footer extends Component {
  render() {
    return (
      <div className={classes.Footer}>
        <div className={classes.FooterSectionLeft}>
          <div className={classes.FooterSectionLeftFirstRow}>
            {/* <Label extraSmall light id={"footer.left.poweredBy"} /> */}
          </div>
          <div className={classes.FooterSectionLeftSecondRow}>
            <Image src={footer_left_brands} alt={"Footer brands"} fitHeight />
          </div>
        </div>
        <div className={classes.FooterSectionCenter} />
        <div className={classes.FooterSectionRight}>
          {/* <Label extraSmall light id={"footer.right.legal"} /> */}
        </div>
      </div>
    );
  }
}
export default Footer;
